export default "__VITE_ASSET__FVb7wtiX__"